import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {PricingCardFeature} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Link from "next/link"
import React from "react"

import styles from "./PricingCardListItem.module.scss"

type Props = {
	coreFeatures: PricingCardFeature
	index: number
	color: "default" | "main"
}

const PricingCardListItem = (props: Props) => {
	// const [hoveredFeature, setHoveredFeature] = useState(-1)

	// const handleFeatureHover = (feature: number) => {
	// 	setHoveredFeature(feature)
	// }
	const isMain = props.color === "main"

	return (
		<li className={styles.feature}>
			{props.coreFeatures?.href && (
				<Link
					className={styles.linkFeature}
					data-testid={"PricingCardListItemLink"}
					href={props.coreFeatures.href}
					rel={"noreferrer"}
					target={"_blank"}
				>
					<Typography
						className={`${styles.featureText}  ${
							styles[props.color]
						}`}
						content={props.coreFeatures.title}
						contrast={isMain}
						variant={Variant.Description}
						size={Size.XXS}
					/>
				</Link>
			)}

			{!props.coreFeatures?.href && (
				<Typography
					className={`${styles.featureText}  ${styles[props.color]}`}
					content={props.coreFeatures.title}
					contrast={isMain}
					variant={Variant.Description}
					size={Size.XXS}
				/>
			)}
			{/* {(props.coreFeatures.additionalInformation && (
				<span
					className={`${styles.featureSymbol}  ${
						styles[props.color]
					}`}
					onMouseEnter={() => handleFeatureHover(props.index)}
					onMouseLeave={() => handleFeatureHover(-1)}
				>
					!
					{hoveredFeature === props.index && (
						<div className={styles.featureDescriptionCard}>
							<Paragraph
								className={styles.featureDescriptionText}
								content={
									props.coreFeatures.additionalInformation
								}
								size={"XS"}
							/>
						</div>
					)}
				</span>
			)) || (
				<span
					className={`${styles.featureSymbol} ${styles.disabled}`}
				/>
			)} */}
		</li>
	)
}

export default PricingCardListItem
